import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-concerts-venues',
	templateUrl: './concerts-venues.component.html',
	styleUrls: ['./concerts-venues.component.scss']
})
export class ConcertsVenuesComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
